﻿export function initViwoFloatingLabels(root = document) {
    const controls = Array.from(root.querySelectorAll(".field-control"));

    controls.forEach(control => {
        if (control.dataset.viwoFloatingInitialized === "true") return;

        const input = control.querySelector("input, textarea, select");

        if (!input) return;

        const disabledForControl =
            control.hasAttribute("data-no-floating-label") ||
            input.hasAttribute("data-no-floating-label");

        if (disabledForControl) {
            control.classList.remove("field-control--float");
            control.dataset.viwoFloatingInitialized = "true";
            return;
        }

        control.dataset.viwoFloatingInitialized = "true";
        control.classList.add("field-control--float");

        syncFloatingState(control, input);

        input.addEventListener("focus", () => {
            control.classList.add("is-focused");
        });

        input.addEventListener("blur", () => {
            control.classList.remove("is-focused");
            syncFloatingState(control, input);
        });

        input.addEventListener("input", () => {
            syncFloatingState(control, input);
        });

        input.addEventListener("change", () => {
            syncFloatingState(control, input);
        });

        if (window.jQuery && window.jQuery.fn?.select2 && input.tagName === "SELECT") {
            window.jQuery(input).on("select2:open", () => {
                control.classList.add("is-focused");
            });

            window.jQuery(input).on("select2:close select2:select change", () => {
                control.classList.remove("is-focused");
                syncFloatingState(control, input);
            });
        }
    });
}

function syncFloatingState(control, input) {
    const hasValue = getInputHasValue(input);

    control.classList.toggle("has-value", hasValue);

    if (input.disabled) {
        control.classList.add("is-disabled");
    } else {
        control.classList.remove("is-disabled");
    }
}

function getInputHasValue(input) {
    if (!input) return false;

    if (input.type === "checkbox" || input.type === "radio") {
        return input.checked;
    }

    if (input.tagName === "SELECT") {
        return String(input.value || "").trim().length > 0;
    }

    return String(input.value || "").trim().length > 0;
}